/*
 * DUO-KUNSTWERKEN — aanbod in de koopzone + popup
 * ===============================================
 * Hoort bij snippets/duo-popup.liquid (markup + config) en de .duo-*-regels in
 * assets/petterns-custom.css.
 *
 * Wat dit bestand doet
 * --------------------
 * 1. leest de gekozen kleur, maat en uitvoering van de PDP
 * 2. haalt het Duo-product op met /products/<handle>.js en zoekt de variant die
 *    bij die kleur en maat hoort
 * 3. toont het aanbod alleen als die variant bestaat, de maat kwalificeert en de
 *    uitvoering geen Twin is
 * 4. laat in de popup design 2 en de twee uitvoeringen kiezen en zet beide werken
 *    met één POST /cart/add.js in de winkelwagen
 * 5. haalt een losse regel van hetzelfde kunstwerk uit de winkelwagen, anders
 *    koopt de klant drie werken terwijl hij er twee bedoelt
 *
 * Twee kleurbronnen
 * -----------------
 * Op de design-PDP zijn alleen Zand en Gebroken wit variantopties; de 48
 * maatwerkkleuren zijn de Globo-property 'Maatwerk kleur' en staan uitsluitend in
 * de DOM. Globo rendert niet server-side, dus die kleur wordt uit .gpo-ov-item
 * gelezen (zelfde selectors als assets/swatch-collapse.js). Is er een
 * maatwerkkleur gekozen, dan wint die van de variantwaarde — precies de afleiding
 * die snippets/cart-item.liquid voor de winkelwagen doet.
 * Op de kinderdier-PDP's zijn alle 50 kleuren gewone varianten, dus daar is de
 * variantwaarde de enige bron.
 *
 * Waar de variantdata vandaan komt
 * --------------------------------
 * snippets/duo-popup.liquid rendert de variantmap van het Duo-product server-side
 * in CFG.duoVarianten, als [id, prijs, optiewaarde...]. Daarmee staat het aanbod
 * al bij de eerste render in beeld. De fetch van /products/<handle>.js blijft
 * bestaan, maar loopt pas na window.load in idle-tijd en verst alleen prijs en
 * leverbaarheid; mislukt hij, dan blijft de server-side map staan.
 * Zonder server-side map (Duo-product bestaat nog niet, of een kleur die alleen
 * Globo kent) is die fetch de enige bron, precies zoals eerder.
 *
 * Prijzen
 * -------
 * Nooit hardcoded. De duo-prijs komt uit de duo-variant, de losse prijs uit de
 * variant van de PDP. De grote prijs rendert als <number-format> (geen valutateken,
 * kleine decimalen); in lopende tekst staat het euroteken er wel, zoals de
 * kleurenstaal-nudge dat al doet.
 *
 * Faalmodus
 * ---------
 * Bestaat het Duo-product nog niet, dan geeft de fetch 404, blijft het aanbod
 * verborgen en komt er geen JS-fout. Hetzelfde geldt voor een ontbrekende
 * kleur-maatcombinatie of een lege designlijst.
 */
(function () {
  'use strict';

  var CDN_FILES  = 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/';
  var CDN_SWATCH = 'https://cdn.shopify.com/s/files/1/0835/2838/4847/t/5/assets/';
  var IMG_V      = '?v=20260419b';

  /* Tussenruimte tussen twee panelen in de combinatieweergave. Gelijk aan
     TWIN_GAP_CM in assets/keuzehulp.js, zodat de twee visualisaties in de shop
     niet uit elkaar lopen. */
  var GAP_CM = 10;

  /* Spec §3: de twee standaardkleuren als lijst van codes, niet als regel op de
     kleurnaam. Alles wat hier niet in staat is op bestelling gemaakt en sluit het
     herroepingsrecht uit. Komt er een standaardkleur bij, dan hoort die hier. */
  var STANDAARD_CODES = ['435_NL', '32'];

  var UITVOERINGEN = ['Inliggend', 'Opliggend'];

  /* Breekpunten. 750 is het bestaande breekpunt van de popup (één kolom naar
     gecentreerd venster), 1025 het theme-breekpunt waarop de popup tweekoloms
     wordt. Moeten gelijk blijven aan de media queries van .duo-sheet in
     assets/petterns-custom.css. */
  var BP_SHEET   = 750;
  var BP_KOLOMMEN = 1025;

  /* ------------------------------------------------------------------
     helpers
  ------------------------------------------------------------------ */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function bedrag(cent) {
    return (cent / 100).toFixed(2).replace('.', ',');
  }

  /* Lopende tekst mag het euroteken hebben (bestaande conventie, cf. de
     kleurenstaal-nudge). De prijszone zelf gebruikt number-format. */
  function euro(cent) {
    return '€' + bedrag(cent);
  }

  function nfHtml(cent) {
    return '<number-format class="price" number="' + (cent / 100) + '"></number-format>';
  }

  /* '463_nl' en '463_NL' en '7' verwijzen naar dezelfde kleur. */
  function norm(code) {
    if (!code) return null;
    if (window.PetternsKleuren && window.PetternsKleuren.normaliseer) {
      var n = window.PetternsKleuren.normaliseer(code);
      if (n) return n;
    }
    var c = String(code).trim().replace(/_nl$/i, '_NL');
    if (/^[0-9]$/.test(c)) c = '0' + c;
    return /^[A-Za-z0-9_]{2,8}$/.test(c) ? c : null;
  }

  /* Kleurcode uit 'Dark Blue (01)' of uit een swatch-bestandsnaam. */
  function codeUit(txt) {
    if (!txt) return null;
    var s = String(txt);
    var m = s.match(/\(\s*([A-Za-z0-9_]{1,8})\s*\)/);
    if (m) return norm(m[1]);
    m = s.match(/kh-swatch-([A-Za-z0-9_]{1,8})\.(?:jpg|jpeg|png|webp)/i);
    if (m) return norm(m[1]);
    return null;
  }

  function isStandaard(code) {
    return STANDAARD_CODES.indexOf(code) !== -1;
  }

  function normMaat(v) {
    return String(v == null ? '' : v).toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function maatCm(label) {
    var m = String(label || '').match(/(\d+)\s*x\s*(\d+)/i);
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : null;
  }

  function naamUit(waarde) {
    return String(waarde || '').split(' (')[0].trim();
  }

  function swatchUrl(code) {
    return CDN_SWATCH + 'kh-swatch-' + code + '.jpg';
  }

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  /* ------------------------------------------------------------------
     init
  ------------------------------------------------------------------ */

  function init() {
    var root = document.querySelector('[data-duo-root]');
    if (!root || root.dataset.duoInit === '1') return;

    var cfgEl = root.querySelector('[data-duo-config]');
    if (!cfgEl) return;

    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!CFG || !CFG.duoHandle) return;
    if (!CFG.designs || CFG.designs.length < 1) return;

    root.dataset.duoInit = '1';

    var offer = root.querySelector('[data-duo-open]');
    var sheet = root.querySelector('[data-duo-sheet]');
    if (!offer || !sheet) return;

    /* De popup naar <body>: binnen de koopkolom kan een sticky- of
       overflow-context eroverheen vallen. Bij een AJAX-hertekening van de
       blokken staat er al een verplaatste popup; die blijft en de nieuwe gaat weg. */
    var bestaand = document.querySelector('body > .duo-sheet[data-duo-moved]');
    if (bestaand) {
      sheet.parentNode.removeChild(sheet);
      sheet = bestaand;
    } else {
      sheet.setAttribute('data-duo-moved', '');
      document.body.appendChild(sheet);
    }

    var q = function (sel) { return sheet.querySelector(sel); };

    var el = {
      offerThumb: offer.querySelector('[data-duo-offer-thumb]'),
      offerSub:   offer.querySelector('[data-duo-offer-sub]'),
      swatch:     q('[data-duo-swatch]'),
      kleurnaam:  q('[data-duo-kleurnaam]'),
      maatwerk:   q('[data-duo-maatwerktag]'),
      maatwrap:   q('[data-duo-maatwrap]'),
      maatnaam:   q('[data-duo-maatnaam]'),
      w1naam:     q('[data-duo-w1naam]'),
      w1img:      q('[data-duo-w1img]'),
      w1type:     q('[data-duo-w1type]'),
      grid:       q('[data-duo-grid]'),
      note:       q('[data-duo-note]'),
      w2img:      q('[data-duo-w2img]'),
      w2naam:     q('[data-duo-w2naam]'),
      w2type:     q('[data-duo-w2type]'),
      wall:       q('[data-duo-wall]'),
      art1:       q('[data-duo-art1]'),
      art2:       q('[data-duo-art2]'),
      img1:       q('[data-duo-img1]'),
      img2:       q('[data-duo-img2]'),
      totaal:     q('[data-duo-totaal]'),
      save:       q('[data-duo-save]'),
      sub:        q('[data-duo-sub]'),
      retour:     q('[data-duo-retour]'),
      retourtxt:  q('[data-duo-retourtxt]'),
      los:        q('[data-duo-los]'),
      add:        q('[data-duo-add]'),
      fout:       q('[data-duo-fout]')
    };

    var state = {
      optKleur: null,
      optMaat:  null,
      optType:  null,
      losPrijs: null,
      duo:      null,   /* product-JSON van het Duo-product */
      design2:  null,
      type1:    'Inliggend',
      type2:    'Inliggend',
      open:     false,
      cartLos:  [],
      bezig:    false
    };

    /* ---------------- huidige PDP-keuze ---------------- */

    function zetOpties(opties) {
      var kleur = null, maat = null, type = null;
      (opties || []).forEach(function (raw) {
        var v = String(raw == null ? '' : raw).trim();
        if (!v) return;
        if (/^\d+\s*x\s*\d+\s*cm$/i.test(v)) maat = v.replace(/\s+/g, ' ');
        else if (/^(inliggend|opliggend)$/i.test(v) || /^twin/i.test(v)) type = v;
        else kleur = v;
      });
      state.optKleur = kleur;
      state.optMaat  = maat;
      state.optType  = type || 'Inliggend';
      if (!/^twin/i.test(state.optType)) {
        state.type1 = /^opliggend$/i.test(state.optType) ? 'Opliggend' : 'Inliggend';
      }
    }

    /* Globo rendert client-side, dus de maatwerkkleur komt uit de DOM. Zelfde
       selectors als assets/swatch-collapse.js; we lezen meerdere bronnen omdat de
       app zijn markup tussen versies verandert. */
    function globoGekozen(item) {
      var inp = item.querySelector && item.querySelector('input[type="radio"]');
      if (inp) return inp.checked;
      var prev = item.previousElementSibling;
      return !!(prev && prev.matches && prev.matches('input[type="radio"]:checked'));
    }

    function globoCode() {
      var bronnen = [];

      document.querySelectorAll('.gpo-ov-wrapper .gpo-ov-item').forEach(function (item) {
        if (!globoGekozen(item)) return;
        var inp = item.querySelector('input[type="radio"]') || item.previousElementSibling;
        if (inp && inp.value) bronnen.push(inp.value);
        var lab = item.querySelector('label');
        if (lab) {
          bronnen.push(lab.getAttribute('title'));
          bronnen.push(lab.getAttribute('aria-label'));
          bronnen.push(lab.getAttribute('data-value'));
        }
        var im = item.querySelector('img');
        if (im) {
          bronnen.push(im.getAttribute('alt'));
          bronnen.push(im.getAttribute('src'));
        }
        bronnen.push(item.getAttribute('data-value'));
        bronnen.push(item.textContent);
      });

      /* Wat Globo bij add-to-cart meestuurt, als de swatch-DOM niets oplevert. */
      document.querySelectorAll('[name*="Maatwerk kleur"]').forEach(function (f) {
        if (f.type === 'radio' || f.type === 'checkbox') {
          if (f.checked) bronnen.push(f.value);
        } else if (f.value) {
          bronnen.push(f.value);
        }
      });

      for (var i = 0; i < bronnen.length; i++) {
        var c = codeUit(bronnen[i]);
        if (c) return c;
      }
      return null;
    }

    function huidigeCode() {
      if (CFG.kleurbron === 'globo') {
        var g = globoCode();
        if (g) return g;
        /* Geen maatwerkkleur: dan is de variantwaarde de kleur. */
        return /gebroken/i.test(state.optKleur || '') ? '32' : '435_NL';
      }
      return codeUit(state.optKleur);
    }

    function huidigeMaat() {
      return CFG.vasteMaat || state.optMaat;
    }

    /* ---------------- duo-variant ---------------- */

    /* Zoekt de duo-variant op kleurcode en maat. Bewust niet op een vaste
       optiepositie: welke optie de kleur is en welke de maat, hangt af van hoe het
       Duo-product is aangemaakt. De kleur wordt herkend aan de code tussen haakjes,
       de maat aan de letterlijke waarde. */
    function duoVariant(code, maat) {
      if (!state.duo || !code) return null;
      var vs = state.duo.variants || [];
      var wilMaat = normMaat(maat);
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i];
        if (!v.available) continue;
        var opties = [v.option1, v.option2, v.option3];
        var heeftKleur = false, heeftMaat = false;
        for (var j = 0; j < 3; j++) {
          var o = opties[j];
          if (o == null || o === '') continue;
          if (codeUit(o) === code) heeftKleur = true;
          else if (normMaat(o) === wilMaat) heeftMaat = true;
        }
        if (!heeftKleur) continue;
        if (CFG.vasteMaat || heeftMaat) return v;
      }
      return null;
    }

    /* De optiewaarde waarin de kleur zit, bijvoorbeeld 'Dark Blue (01)'. */
    function duoKleurWaarde(v, code) {
      if (!v) return null;
      var opties = [v.option1, v.option2, v.option3];
      for (var i = 0; i < 3; i++) {
        if (opties[i] && codeUit(opties[i]) === code) return opties[i];
      }
      return null;
    }

    function maatKwalificeert() {
      if (CFG.vasteMaat) return true;
      var m = normMaat(state.optMaat);
      return (CFG.maten || []).some(function (x) { return normMaat(x) === m; });
    }

    function typeKwalificeert() {
      /* Een Twin is al twee panelen. */
      return !/^twin/i.test(state.optType || '');
    }

    /* ---------------- beelden ---------------- */

    function renderUrl(handle, uitvoering, code) {
      return CDN_FILES + 'kh-kleur-' + CFG.slug + '-' + handle + '-' +
        (/^opliggend$/i.test(uitvoering) ? 'opliggend' : 'inliggend') + '-' +
        String(code).toLowerCase() + '.jpg' + IMG_V;
    }

    /* Valt het kleurbeeld weg, dan de productfoto; valt die ook weg, dan een leeg
       vlak in plaats van een gebroken afbeelding. */
    function zetBeeld(img, url, fallback, naam) {
      if (!img) return;
      img.alt = naam || '';
      img.setAttribute('data-duo-fb', fallback || '');
      img.onerror = function () {
        var fb = this.getAttribute('data-duo-fb');
        this.setAttribute('data-duo-fb', '');
        if (fb) { this.src = fb; return; }
        this.onerror = null;
        this.removeAttribute('src');
        this.style.visibility = 'hidden';
      };
      img.style.visibility = '';
      img.src = url;
    }

    function designVan(handle) {
      var d = null;
      (CFG.designs || []).forEach(function (x) { if (x.handle === handle) d = x; });
      return d;
    }

    /* ---------------- het aanbod ---------------- */

    /* Het sterretje bij de kwalificerende maten en de voetnoot eronder komen uit
       snippets/variant-button.liquid en staan er dus al bij de eerste render. Het
       enige dat na een klik kan veranderen is de uitvoering: bij Twin geldt het
       aanbod niet, dus dan gaan het teken en de voetnoot samen weg. Een
       voetnootteken zonder voetnoot verwijst naar niets.
       Het sterretje verdwijnt met visibility (zie petterns-custom.css), dus de
       knoppenrij verspringt niet.
       Wat hier bewust niet gebeurt: sterretjes toevoegen. Of een maat kwalificeert
       hangt aan het bestaan van het Duo-product, en dat weet Liquid al. */
    function verversMaatlabel() {
      var wrap = document.querySelector('[data-duo-maatlabel]');
      if (!wrap) return;
      var uit = !typeKwalificeert();
      wrap.classList.toggle('duo-maatlabel--uit', uit);
      var noot = wrap.querySelector('[data-duo-maatnoot]');
      if (noot) noot.hidden = uit;
    }

    function verversOffer() {
      verversMaatlabel();
      var code = huidigeCode();
      var maat = huidigeMaat();
      var v = (maatKwalificeert() && typeKwalificeert()) ? duoVariant(code, maat) : null;

      if (!v || !state.losPrijs) {
        offer.hidden = true;
        if (state.open) sluit();
        return;
      }

      offer.hidden = false;
      var los = state.losPrijs * 2;
      if (el.offerSub) {
        el.offerSub.innerHTML =
          'Kies een tweede design in dezelfde kleur en maat, samen <b>' +
          euro(v.price) + '</b> in plaats van ' + euro(los) + '.';
      }
      zetBeeld(el.offerThumb, renderUrl(CFG.werk1.handle, state.optType, code),
        CFG.werk1.img, CFG.werk1.naam);

      if (state.open) verversSheet();
    }

    /* ---------------- de popup ---------------- */

    function pills(container, actief, klik) {
      if (!container) return;
      container.innerHTML = '';
      UITVOERINGEN.forEach(function (w) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pt-chip duo-pill' + (w === actief ? ' is-active' : '');
        b.textContent = w;
        b.setAttribute('aria-pressed', w === actief ? 'true' : 'false');
        b.addEventListener('click', function () { klik(w); });
        container.appendChild(b);
      });
    }

    function bouwGrid(code) {
      if (!el.grid) return;
      el.grid.innerHTML = '';
      (CFG.designs || []).forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'duo-dtile';
        b.setAttribute('aria-pressed', state.design2 === d.handle ? 'true' : 'false');

        var img = document.createElement('img');
        img.className = 'duo-dtile__im';
        b.appendChild(img);
        zetBeeld(img, renderUrl(d.handle, state.type2, code), d.img, d.naam);

        var n = document.createElement('span');
        n.className = 'duo-dtile__n';
        n.textContent = d.naam;
        b.appendChild(n);

        if (d.handle === CFG.werk1.handle) {
          var same = document.createElement('span');
          same.className = 'duo-dtile__same';
          same.textContent = '= werk 1';
          b.appendChild(same);
        }

        var ck = document.createElement('span');
        ck.className = 'duo-dtile__ck';
        ck.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5.5 5.5L20 6"/></svg>';
        b.appendChild(ck);

        b.addEventListener('click', function () {
          hintGezien = true;
          stopHintLus();
          state.design2 = d.handle;
          verversSheet();
        });
        el.grid.appendChild(b);
      });
    }

    function verversSheet() {
      var code = huidigeCode();
      var maat = huidigeMaat();
      var v = duoVariant(code, maat);
      if (!v) { sluit(); return; }

      var kleurwaarde = duoKleurWaarde(v, code);
      var kleurnaam = naamUit(kleurwaarde) || naamUit(state.optKleur) || code;

      if (el.swatch) el.swatch.style.backgroundImage = 'url("' + swatchUrl(code) + '")';
      if (el.kleurnaam) el.kleurnaam.textContent = kleurnaam + ' (' + code + ')';
      if (el.maatwerk) el.maatwerk.hidden = isStandaard(code);
      if (el.maatnaam) el.maatnaam.textContent = maat || '';
      if (el.maatwrap) el.maatwrap.hidden = !maat;
      if (el.w1naam) el.w1naam.textContent = CFG.werk1.naam;

      zetBeeld(el.w1img, renderUrl(CFG.werk1.handle, state.type1, code), CFG.werk1.img, CFG.werk1.naam);
      pills(el.w1type, state.type1, function (w) { state.type1 = w; verversSheet(); });
      pills(el.w2type, state.type2, function (w) { state.type2 = w; verversSheet(); });
      bouwGrid(code);

      var d2 = designVan(state.design2);
      if (d2) {
        zetBeeld(el.w2img, renderUrl(d2.handle, state.type2, code), d2.img, d2.naam);
        if (el.w2naam) el.w2naam.textContent = d2.naam + ', kies de uitvoering';
      } else {
        if (el.w2img) { el.w2img.onerror = null; el.w2img.removeAttribute('src'); el.w2img.alt = ''; el.w2img.style.visibility = 'hidden'; }
        if (el.w2naam) el.w2naam.textContent = 'Kies hierboven je tweede design';
      }

      if (el.note) {
        if (state.design2 === CFG.werk1.handle) {
          el.note.hidden = false;
          el.note.textContent = 'Twee keer ' + CFG.werk1.naam +
            ', dat mag. Je krijgt hetzelfde design twee keer, met dezelfde korting.';
        } else {
          el.note.hidden = true;
        }
      }

      if (el.totaal) el.totaal.innerHTML = nfHtml(v.price);
      var losTotaal = state.losPrijs ? state.losPrijs * 2 : 0;
      if (el.save) {
        el.save.hidden = !losTotaal;
        if (losTotaal) el.save.innerHTML = 'je bespaart <b>' + euro(losTotaal - v.price) + '</b>';
      }
      if (el.sub) {
        el.sub.innerHTML = losTotaal
          ? 'Los gekocht betaal je ' + euro(losTotaal) + ' voor twee. Incl. btw.'
          : 'Incl. btw.';
      }

      /* Herroepingsrecht per kleur: 48 van de 50 kleuren zijn op bestelling
         gemaakt. De uitsluiting moet vóór de aankoop duidelijk zijn, dus staat
         hij direct boven de knop. */
      if (el.retour) {
        if (isStandaard(code)) {
          el.retour.hidden = true;
        } else {
          el.retour.hidden = false;
          if (el.retourtxt) {
            /* Eén regel in plaats van twee. De mededeling zelf blijft voluit
               staan: de uitsluiting van het herroepingsrecht mag niet worden
               weggestopt (spec par. 3). */
            el.retourtxt.innerHTML = esc(kleurnaam) +
              ' is een maatwerkkleur, <b>retourneren is niet mogelijk</b>.';
          }
        }
      }

      if (el.los) {
        if (CFG.verwijderLos && state.cartLos.length) {
          el.los.hidden = false;
          el.los.textContent = CFG.werk1.naam +
            ' staat al los in je winkelwagen. Die regel halen we eruit, want dit duo bevat dat kunstwerk al.';
        } else {
          el.los.hidden = true;
        }
      }

      if (el.add) {
        el.add.disabled = !state.design2 || state.bezig;
        el.add.textContent = state.bezig
          ? 'Toevoegen…'
          : (state.design2 ? 'Voeg beide kunstwerken toe' : 'Kies eerst je tweede design');
      }
      if (el.fout) el.fout.hidden = true;

      verversCombi(code);
    }

    /* Combinatieweergave: beide werken op schaal naast elkaar, met de echte
       tussenruimte. Geen referentiemuur met silhouet: in een popup worden de
       designs dan te klein om te beoordelen. */
    /* Tijdelijke diagnose. Alleen actief met ?duodebug=1 in de URL, zodat op een
       echt toestel af te lezen is wat de combinatieweergave meet. */
    var DEBUG = false;
    try { DEBUG = /[?&]duodebug=1/.test(window.location.search); } catch (e) {}

    function duoDebug(waarden) {
      if (!DEBUG) return;
      var box = document.getElementById('duo-debug');
      if (!box) {
        box = document.createElement('div');
        box.id = 'duo-debug';
        box.style.cssText = 'position:fixed;left:6px;top:6px;z-index:99999;max-width:70vw;' +
          'padding:8px 10px;border-radius:8px;background:rgba(20,20,20,.88);color:#fff;' +
          'font:11px/1.45 ui-monospace,Menlo,monospace;white-space:pre;pointer-events:none';
        document.body.appendChild(box);
      }
      var uit = [];
      for (var k in waarden) if (Object.prototype.hasOwnProperty.call(waarden, k)) {
        uit.push(k + ': ' + waarden[k]);
      }
      box.textContent = uit.join('\n');
    }

    function verversCombi(code) {
      if (!el.wall || !el.art1 || !el.art2) return;
      code = code || huidigeCode();
      var cm = maatCm(huidigeMaat());
      if (!cm) return;

      var cs = getComputedStyle(el.wall);
      var pad = parseFloat(cs.paddingLeft || 0) + parseFloat(cs.paddingRight || 0);
      var binnen = el.wall.clientWidth - pad;
      /* Een te kleine meting maakt de bréédte bindend in plaats van de hoogte, en
         dan krimpt de weergave tot een fractie. Dat gebeurde als de klant eerst had
         gescrold: de sticky koopbalk was er dan bij gekomen en de layout was op het
         meetmoment nog niet af. De oude ondergrens van 40px ving dat niet, want de
         meting kwam op zo'n 150px uit. Onder een breedte die voor deze popup
         onmogelijk is, rekenen we met de vensterbreedte; de ResizeObserver
         herberekent zodra de echte breedte bekend is. */
      var ondergrens = Math.min(240, Math.max(200, window.innerWidth - 90));
      if (!binnen || binnen < ondergrens) {
        binnen = Math.max(240, Math.min(520, window.innerWidth - 56 - pad));
      }
      /* Maximumhoogte van de combinatieweergave. Het hoogste geval is de
         panorama (1:2), dus de hoogte is bindend en niet de breedte. Op de
         tweekoloms-desktop staat het beeld in zijn eigen kolom en verdringt het
         de keuze niet meer, maar bij een lage viewport zou het de linkerkolom
         nog wel laten scrollen: daarom daar 30% van de vensterhoogte, begrensd
         op 260px. */
      var maxH;
      if (window.innerWidth < BP_SHEET) maxH = 165;
      else if (window.innerWidth >= BP_KOLOMMEN) {
        maxH = Math.max(170, Math.min(260, Math.round(window.innerHeight * 0.30)));
      } else maxH = 250;

      var totCm = cm.w * 2 + GAP_CM;
      var scale = Math.min(binnen / totCm, maxH / cm.h);
      var wpx = cm.w * scale, hpx = cm.h * scale;

      duoDebug({
        'venster': window.innerWidth + ' x ' + window.innerHeight,
        'wall.clientWidth': el.wall.clientWidth,
        'padding': Math.round(pad),
        'binnen (gebruikt)': Math.round(binnen),
        'ondergrens': Math.round(ondergrens),
        'maxH': maxH,
        'maat cm': cm.w + ' x ' + cm.h,
        'scale': scale.toFixed(3),
        'werk px': Math.round(wpx) + ' x ' + Math.round(hpx),
        'sticky ATC': (document.querySelector('.petterns-sticky-atc.is-visible') ? 'zichtbaar' : 'nee'),
        'box hoogte': (function () { var b = document.querySelector('.duo-sheet__box'); return b ? Math.round(b.getBoundingClientRect().height) : '?'; })(),
        'body hoogte': (function () { var b = document.querySelector('.duo-sheet__body'); return b ? Math.round(b.getBoundingClientRect().height) : '?'; })()
      });

      el.wall.style.gap = (GAP_CM * scale).toFixed(1) + 'px';
      [el.art1, el.art2].forEach(function (a) {
        a.style.width = wpx.toFixed(1) + 'px';
        a.style.height = hpx.toFixed(1) + 'px';
      });

      zetBeeld(el.img1, renderUrl(CFG.werk1.handle, state.type1, code), CFG.werk1.img, CFG.werk1.naam);

      var d2 = designVan(state.design2);
      if (d2) {
        el.art2.classList.remove('duo-combi__art--leeg');
        if (el.img2) { el.img2.style.display = ''; }
        zetBeeld(el.img2, renderUrl(d2.handle, state.type2, code), d2.img, d2.naam);
      } else {
        el.art2.classList.add('duo-combi__art--leeg');
        if (el.img2) { el.img2.onerror = null; el.img2.removeAttribute('src'); el.img2.style.display = 'none'; }
      }
    }

    /* ---------------- open en sluiten ---------------- */

    var laatsteFocus = null;

    /* Het designraster is een horizontale scroller. Als niet alle designs passen,
       schuift hij even heen en terug, zodat zichtbaar is dat er meer staat dan in
       beeld. Zonder die hint mist een klant op een smal scherm de helft van de keuze.
       Gaat niet af als alles al past, en niet bij prefers-reduced-motion.

       Op touch herhaalt de hint zolang de klant niets doet: één keer aan het begin
       wordt makkelijk gemist. Zodra hij scrolt, tikt of een design kiest stopt het,
       en dan komt het niet meer terug. Op muis-apparaten gebeurt het niet, daar staan
       de pijlen. */
    var HINT_MS = 6000;
    var hintLus = null;
    var hintGezien = false;

    function isTouchOnly() {
      try { return !window.matchMedia('(hover: hover) and (pointer: fine)').matches; }
      catch (e) { return false; }
    }

    function stopHintLus() {
      if (hintLus) { clearInterval(hintLus); hintLus = null; }
    }

    function startHintLus() {
      stopHintLus();
      if (hintGezien || !isTouchOnly()) return;
      var g = el.grid;
      if (!g || g.scrollWidth <= g.clientWidth + 1) return;
      hintLus = setInterval(function () {
        if (hintGezien || !state.open) { stopHintLus(); return; }
        scrollHint();
      }, HINT_MS);
    }

    /* Elke echte interactie zet de hint definitief uit. */
    function koppelHintStop() {
      var g = el.grid;
      if (!g || g.dataset.duoHintAan) return;
      g.dataset.duoHintAan = '1';
      var uit = function () { hintGezien = true; stopHintLus(); };
      ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (ev) {
        g.addEventListener(ev, uit, { passive: true });
      });
      g.addEventListener('click', uit);
    }

    function scrollHint() {
      var g = el.grid;
      if (!g) return;
      if (g.scrollWidth <= g.clientWidth + 1) return;
      try {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      } catch (e) {}
      var heen = Math.min(52, g.scrollWidth - g.clientWidth);
      if (heen < 8) return;
      try {
        g.scrollTo({ left: heen, behavior: 'smooth' });
        setTimeout(function () { g.scrollTo({ left: 0, behavior: 'smooth' }); }, 460);
      } catch (e) {
        g.scrollLeft = heen;
        setTimeout(function () { g.scrollLeft = 0; }, 460);
      }
    }

    /* Pijlen naast de scroller: verschijnen alleen als er in die richting nog
       iets staat. Aan het begin geen linkerpijl, aan het eind geen rechter. */
    function verversNav() {
      var g = el.grid;
      if (!g) return;
      var wrap = g.parentNode;
      if (!wrap || !wrap.querySelectorAll) return;
      var knoppen = wrap.querySelectorAll('[data-duo-nav]');
      if (!knoppen.length) return;
      var kanScrollen = g.scrollWidth > g.clientWidth + 1;
      var x = g.scrollLeft;
      var max = g.scrollWidth - g.clientWidth;
      for (var i = 0; i < knoppen.length; i++) {
        var richting = parseInt(knoppen[i].getAttribute('data-duo-nav'), 10);
        var zichtbaar = kanScrollen && (richting < 0 ? x > 2 : x < max - 2);
        knoppen[i].hidden = !zichtbaar;
      }
    }

    function koppelNav() {
      var g = el.grid;
      if (!g || g.dataset.duoNavAan) return;
      g.dataset.duoNavAan = '1';
      var wrap = g.parentNode;
      if (wrap && wrap.addEventListener) {
        wrap.addEventListener('click', function (e) {
          var k = e.target.closest ? e.target.closest('[data-duo-nav]') : null;
          if (!k) return;
          var richting = parseInt(k.getAttribute('data-duo-nav'), 10) || 1;
          // ongeveer twee tegels per klik, en nooit voorbij de rand
          var stap = Math.max(120, Math.round(g.clientWidth * 0.7));
          try { g.scrollBy({ left: richting * stap, behavior: 'smooth' }); }
          catch (err) { g.scrollLeft += richting * stap; }
        });
      }
      g.addEventListener('scroll', verversNav, { passive: true });
      if (window.addEventListener) window.addEventListener('resize', verversNav);
    }

    /* De combinatieweergave schaalt op de breedte van el.wall. Die breedte één keer
       meten na het openen ging mis: had de klant eerst gescrold, dan was de sticky
       koopbalk erbij gekomen en was de layout op dat moment nog niet af, waardoor
       clientWidth te klein uitviel en de weergave terugviel op de noodwaarde van
       280px. In plaats van beter te timen: reageren op de echte breedte zodra die
       verandert. Alleen op breedteverschil, want verversCombi zet zelf hoogtes en
       dat zou anders terugkoppelen. */
    var wallRO = null;
    var wallBreedte = 0;

    function koppelWallObserver() {
      if (wallRO || !el.wall) return;
      if (typeof ResizeObserver === 'undefined') return;
      wallRO = new ResizeObserver(function (entries) {
        if (!state.open) return;
        var b = Math.round(entries[0].contentRect.width);
        if (b === wallBreedte || b < 40) return;
        wallBreedte = b;
        verversCombi();
      });
      wallRO.observe(el.wall);
    }

    function open() {
      if (offer.hidden) return;
      laatsteFocus = document.activeElement;
      state.open = true;
      sheet.hidden = false;
      document.body.classList.add('duo-lock');
      leesCart().then(function () {
        verversSheet();
        koppelWallObserver();
        // meteen, en nog eens zodra de layout is uitgekristalliseerd
        requestAnimationFrame(function () {
          verversCombi();
          requestAnimationFrame(function () { verversCombi(); });
        });
        var x = sheet.querySelector('.duo-sheet__x');
        if (x) x.focus();
        // na de render, zodat scrollWidth klopt
        koppelNav();
        koppelHintStop();
        verversNav();
        setTimeout(function () {
          scrollHint();
          verversNav();
          startHintLus();
        }, 420);
      });
    }

    function sluit() {
      if (!state.open) return;
      stopHintLus();
      wallBreedte = 0;
      state.open = false;
      sheet.hidden = true;
      document.body.classList.remove('duo-lock');
      if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus();
    }

    /* ---------------- winkelwagen ---------------- */

    function leesCart() {
      if (!CFG.verwijderLos) { state.cartLos = []; return Promise.resolve(); }
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          state.cartLos = (cart.items || []).filter(function (it) {
            return it.product_id === CFG.productId;
          });
        })
        .catch(function () { state.cartLos = []; });
    }

    function verwijderLosseRegels() {
      if (!CFG.verwijderLos || !state.cartLos.length) return Promise.resolve();
      /* Eén voor één: /cart/change.js verwerkt geen batch en de keys schuiven niet
         op zolang we op key en niet op regelnummer wijzigen. */
      return state.cartLos.reduce(function (p, it) {
        return p.then(function () {
          return jsonPost('/cart/change.js', { id: it.key, quantity: 0 }).catch(function () {});
        });
      }, Promise.resolve());
    }

    function voegToe() {
      var code = huidigeCode();
      var v = duoVariant(code, huidigeMaat());
      var d2 = designVan(state.design2);
      if (!v || !d2 || state.bezig) return;

      state.bezig = true;
      if (el.add) { el.add.disabled = true; el.add.textContent = 'Toevoegen…'; }
      if (el.fout) el.fout.hidden = true;

      var props = {};
      props['Design 1'] = CFG.werk1.naam;
      props['Design 2'] = d2.naam;
      props['Uitvoering 1'] = state.type1;
      props['Uitvoering 2'] = state.type2;

      jsonPost('/cart/add.js', { items: [{ id: v.id, quantity: 1, properties: props }] })
        .then(function () {
          /* Pas opruimen als het duo er echt in staat: anders is de klant zijn
             losse regel kwijt zonder dat hij iets terugkrijgt. */
          return verwijderLosseRegels();
        })
        .then(function () {
          state.bezig = false;
          state.cartLos = [];
          /* Volgende keer opnieuw beginnen: design 2 staat weer leeg, zoals bij
             de eerste keer openen. */
          state.design2 = null;
          if (el.add) {
            el.add.disabled = true;
            el.add.textContent = 'Kies eerst je tweede design';
          }
          sluit();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'duo_add_to_cart', {
              duo_vorm: CFG.vorm,
              duo_kleur: naamUit(duoKleurWaarde(v, code)),
              duo_maat: huidigeMaat() || '',
              duo_design_1: CFG.werk1.naam,
              duo_design_2: d2.naam
            });
          }
        })
        .catch(function () {
          state.bezig = false;
          if (el.fout) el.fout.hidden = false;
          verversSheet();
        });
    }

    /* ---------------- losse prijs van de PDP ---------------- */

    function leesLosPrijsUitDom() {
      var ta = document.querySelector('[data-variant-json]');
      if (!ta) return;
      var lijst;
      try { lijst = JSON.parse(ta.textContent); } catch (e) { return; }
      (lijst || []).forEach(function (v) {
        if (v.id === CFG.losseVariantId) state.losPrijs = v.price;
      });
    }

    /* ---------------- events ---------------- */

    zetOpties(CFG.huidigeOpties);
    if (typeof CFG.losPrijs === 'number') state.losPrijs = CFG.losPrijs;
    leesLosPrijsUitDom();
    leesDuoUitLiquid();

    offer.addEventListener('click', open);

    /* De voetnoot bij de maatkeuze opent hetzelfde aanbod. Die staat buiten root
       (in variant-button.liquid), vandaar een aparte koppeling. Hij mag alleen
       openen als het aanbod zelf ook beschikbaar is; open() bewaakt dat al via
       offer.hidden. */
    /* De voetnoot staat bij de maatrij en dus bóven de kleurkeuze. Meteen de popup
       openen zou de standaardkleur meenemen, terwijl de klant die nooit bewust koos
       en de 48 maatwerkkleuren onder de vouw staan. Daarom: scrollen naar de
       kleurkeuze, met het aanbod eronder in beeld. De scrollpositie wijst naar de
       keuze, een eenmalige puls op het aanbod wijst naar de actie. */
    var pulsGehad = false;

    function naarKleurkeuze() {
      var doel = document.querySelector('[data-duo-kleurgroep]') || offer;
      var offerRect = offer.getBoundingClientRect();
      var alZichtbaar = offerRect.top >= 0 && offerRect.bottom <= window.innerHeight;
      var zacht = true;
      try {
        zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      if (!alZichtbaar) {
        var y = window.pageYOffset + doel.getBoundingClientRect().top - 16;
        try { window.scrollTo({ top: y, behavior: zacht ? 'smooth' : 'auto' }); }
        catch (e) { window.scrollTo(0, y); }
      }
      if (!pulsGehad && zacht) {
        pulsGehad = true;
        setTimeout(function () {
          offer.classList.add('duo-offer--puls');
          setTimeout(function () { offer.classList.remove('duo-offer--puls'); }, 1300);
        }, alZichtbaar ? 60 : 480);
      }
    }

    var maatnoot = document.querySelector('[data-duo-maatnoot]');
    if (maatnoot && maatnoot !== offer) maatnoot.addEventListener('click', naarKleurkeuze);
    sheet.querySelectorAll('[data-duo-close]').forEach(function (b) {
      b.addEventListener('click', sluit);
    });
    if (el.add) el.add.addEventListener('click', voegToe);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) sluit();
    });

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      zetOpties(v.options);
      if (typeof v.price === 'number') state.losPrijs = v.price;
      verversOffer();
    });

    /* Globo heeft geen event, dus we hermeten na elke klik of change in de
       koopzone. Goedkoop: het is één DOM-query op de swatchrij. */
    var hermeetTimer = null;
    function hermeet(e) {
      if (e && e.target && sheet.contains(e.target)) return;
      clearTimeout(hermeetTimer);
      hermeetTimer = setTimeout(verversOffer, 60);
    }
    document.addEventListener('change', hermeet, true);
    document.addEventListener('click', hermeet, true);

    window.addEventListener('resize', function () {
      if (state.open) verversCombi();
    });

    /* ---------------- duo-product: server-side eerst ---------------- */

    /* De variantmap uit Liquid, compact als [id, prijs, optiewaarde...]. Die
       wordt hier omgezet naar de vorm die /products/<handle>.js ook levert,
       zodat duoVariant() en duoKleurWaarde() niet hoeven te weten waar de data
       vandaan komt. Liquid rendert alleen leverbare varianten. */
    function leesDuoUitLiquid() {
      var rijen = CFG.duoVarianten;
      if (!rijen || !rijen.length) return;
      var vs = [];
      for (var i = 0; i < rijen.length; i++) {
        var r = rijen[i];
        if (!r || r.length < 2) continue;
        vs.push({
          id: r[0],
          price: r[1],
          available: true,
          option1: r.length > 2 ? r[2] : null,
          option2: r.length > 3 ? r[3] : null,
          option3: r.length > 4 ? r[4] : null
        });
      }
      if (vs.length) state.duo = { variants: vs };
    }

    function haalDuo() {
      fetch('/products/' + CFG.duoHandle + '.js', {
        credentials: 'same-origin', headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (data && data.variants && data.variants.length) {
            state.duo = data;
            verversOffer();
          }
        })
        .catch(function () {
          /* Mislukt de fetch, dan blijft de server-side map staan. Is die er
             niet (Duo-product bestaat nog niet), dan geen aanbod en geen fout. */
          if (!state.duo) offer.hidden = true;
        });
    }

    /* Gaf Liquid al een variantmap, dan is het aanbod nu al compleet: hier
       alleen nog bijwerken voor wat Liquid niet kon weten (een maatwerkkleur uit
       Globo). Het aanbod staat dan al in de HTML, dus dit verschuift niets. */
    if (state.duo) verversOffer();

    /* De fetch verst prijs en leverbaarheid en is de enige bron zonder
       server-side map. Niet in de kritieke render: de PDP is al zwaar genoeg. */
    if (document.readyState === 'complete') {
      startLaden();
    } else {
      window.addEventListener('load', startLaden, { once: true });
    }

    function startLaden() {
      if (window.requestIdleCallback) window.requestIdleCallback(haalDuo, { timeout: 1500 });
      else setTimeout(haalDuo, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
